import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-20 bg-terracotta text-white relative overflow-hidden" data-id="element-145">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-146">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-147">
          <path d="M0,0 L100,0 L100,100 L0,100 Z" fill="url(#pattern)" data-id="element-148" />
          <defs data-id="element-149">
            <pattern id="pattern" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-150">
              <circle cx="2" cy="2" r="1" fill="currentColor" data-id="element-151" />
            </pattern>
          </defs>
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center" data-id="element-152">
        <FadeIn data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 leading-tight" data-id="element-154">
            En solo 7 días...
          </h2>
          <p className="text-xl md:text-2xl font-light leading-relaxed opacity-90" data-id="element-155">
            Dejarás de tomarte el comportamiento de tu hijo como un ataque
            personal. Pasarás de la reacción automática al entendimiento
            profundo, logrando que los berrinches que antes duraban 30 minutos
            se resuelvan en una conexión de 5.
          </p>
        </FadeIn>
      </div>
    </section>;
}